// Disclaimer: Boutique-Only-Abholung
document.addEventListener('DOMContentLoaded', function () {
  function waitForDisclaimer() {
    if (!document.querySelector('#buunto-boutique-only-abholung')) {
      setTimeout(waitForDisclaimer, 200);
      return;
    }
    initDisclaimer();
  }

  function initDisclaimer() {
    const box = document.querySelector('#buunto-boutique-only-abholung');
    if (!box) return;

    const TRIGGER = 'buunto-boutique-only-abholung';

    function cartHasTag() {
      return Array.from(document.querySelectorAll('cart-item.cart-item')).some(el =>
        (el.dataset.tags || '')
          .toLowerCase()
          .split(',')
          .map(t => t.trim())
          .includes(TRIGGER)
      );
    }

    function validate() {
  const hasTag = cartHasTag();
  box.style.display = hasTag ? 'block' : 'none';

  // Free-Shipping-Bar target
  const fsBar = document.querySelector('cart-free-shipping-bar-block');

  if (fsBar) {
    fsBar.style.display = hasTag ? 'none' : ''; 
  }

  console.log(`BoutiqueOnly DEBUG: tagPresent=${hasTag}`);
}


    const cartContainer = document.querySelector(
      'form[action="/cart"], .cart-items, #CartContainer'
    );
    if (cartContainer) {
      const observer = new MutationObserver(() => {
        setTimeout(validate, 100);
      });
      observer.observe(cartContainer, { childList: true, subtree: true });
    }

    setInterval(validate, 600);
    validate();
  }

  waitForDisclaimer();
});
